import { render } from "./UpdateAdmin.vue?vue&type=template&id=034f631d"
import script from "./UpdateAdmin.vue?vue&type=script&lang=js"
export * from "./UpdateAdmin.vue?vue&type=script&lang=js"

import "./UpdateAdmin.vue?vue&type=style&index=0&id=034f631d&lang=css"

import exportComponent from "/codebuild/output/src1559117955/src/employer_portal_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__